import script from "./VModalWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./VModalWrapper.vue?vue&type=script&setup=true&lang=js"

import "./VModalWrapper.vue?vue&type=style&index=0&id=1da3b3be&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da3b3be"]])

export default __exports__